/* Blog post: builds the "In this Article" TOC from the article's h2 headings,
   scrolls to a heading on click and highlights the current one while scrolling. */
(function () {
  function init() {
    var toc = document.querySelector('[data-article-toc]');
    var content = document.querySelector('.m-article__content');
    if (!toc || !content) return;

    var list = toc.querySelector('[data-article-toc-list]');
    var toggle = toc.querySelector('[data-article-toc-toggle]');
    var section = toc.closest('.m-article');

    var headings = Array.prototype.filter.call(content.querySelectorAll('h2'), function (h) {
      return h.textContent.trim() !== '';
    });

    // Nothing to navigate: leave the TOC hidden
    if (headings.length < 2) return;

    var used = {};
    var items = [];

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var slug = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        var id = slug || 'section';
        if (used[id] || document.getElementById(id)) id = id + '-' + (index + 1);
        heading.id = id;
      }
      used[heading.id] = true;

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'm-article-toc__item';
      item.textContent = heading.textContent.trim();
      item.dataset.target = heading.id;
      item.addEventListener('click', function () {
        setActive(item);
        var top = heading.getBoundingClientRect().top + window.pageYOffset - getOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + heading.id);
        // Collapse the list again on mobile after jumping
        if (window.innerWidth < 1024) toc.classList.remove('is--active');
      });

      list.appendChild(item);
      items.push({ heading: heading, item: item });
    });

    section.classList.add('m-article--has-toc');

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = toc.classList.toggle('is--active');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Space to keep clear at the top of the viewport (sticky header + breathing room)
    function getOffset() {
      var offset = 20;
      var header = document.querySelector('.header-sticky-always .m-header__wrapper, .m-header.stuck');
      if (header) offset += header.getBoundingClientRect().height;
      return offset;
    }

    function updateOffset() {
      toc.style.setProperty('--m-toc-offset', getOffset() + 'px');
      section.style.setProperty('--m-toc-offset', getOffset() + 'px');
    }

    function setActive(activeItem) {
      items.forEach(function (entry) {
        entry.item.classList.toggle('active', entry.item === activeItem);
      });
    }

    // Scroll spy: the active item is the last heading that has passed the offset line
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var line = getOffset() + 10;
        var current = null;
        items.forEach(function (entry) {
          if (entry.heading.getBoundingClientRect().top <= line) current = entry.item;
        });
        // Before the first heading: keep the first item highlighted
        setActive(current || items[0].item);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateOffset);
    updateOffset();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
